module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen5-27679752cfbce4a28d735e8d4fecbfc9.png";